import cloneDeep from 'lodash/cloneDeep';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  const data = cloneDeep(serverTableData);
  return generalTransformer(data);
}
